import Apollo from '@/store/interfaces/Apollo'
import gql from 'graphql-tag'
import { storage } from '@/utils/storage'

const apollo = new Apollo(process.env.VUE_APP_CRAFT_API, false)
apollo.setToken('Bearer ' + process.env.VUE_APP_CRAFT_TOKEN)
const graphqlClient = apollo.client

const site = process.env.VUE_APP_CRAFT_WEBSITE

class APICraft {

  getGlobal () {
    const args = arguments

    const request = new Promise((resolve, reject) => {
      graphqlClient.query({
        query: gql`
          query fetchGlobal {
            categories(site: "${site}", group: ["clermontType", "clermontStatus"]) {
              ... on clermontType_Category {
                id
                slug
                color
                title
                groupHandle
                image {
                  url
                  id
                }
              }
              ... on clermontStatus_Category {
                id
                slug
                color
                title
                groupHandle
                image {
                  url
                  id
                }
              }
            }
          }

        `
      })
      .then(res => {
        const result = res.data

        resolve(result)
        storage.setItem( `fetchGlobal_${JSON.stringify(args)}`, result)
      })
      .catch(err => {
        console.error('Error catching global params ', err)
      })
    })
    const cache = storage.getItem( `fetchGlobal_${JSON.stringify(args)}`)

    return {
      request,
      cache
    }
  }

  getMember (categories) {
    const args = arguments

    const request = new Promise((resolve, reject) => {
      graphqlClient.query({
        query: gql`
          query fetchEntries ($categories: [QueryArgument]) {
            entries(site: "${site}", section: "clermontMember", clermontStatus: $categories) {
              ... on clermontMember_clermontMember_Entry {
                id
                slug
                title
                geolocalisation {
                  lat
                  lng
                }
                clermontElipseSize
                clermontHeight
                population: clermontPopulation
                clermontStatus {
                  ... on clermontStatus_Category {
                    id
                    slug
                    color
                    title
                    image {
                      url
                      id
                    }
                  }
                }
              }
            }
          }
        `,
        variables: { categories }
      })
      .then(res => {
        const result = res.data.entries

        resolve(result)
        storage.setItem( `fetchMembers_${JSON.stringify(args)}`, result)
      })
      .catch(err => {
        console.error('Error catching global params ', err)
      })
    })
    const cache = storage.getItem( `fetchMembers_${JSON.stringify(args)}`)

    return {
      request,
      cache
    }
  }

  getCulture (categories) {
    const args = arguments

    const request = new Promise((resolve, reject) => {
      graphqlClient.query({
        query: gql`
          query fetchEntries ($categories: [QueryArgument]) {
            entries(site: "${site}", section: "clermontCulture", clermontType: $categories) {
              ... on clermontCulture_clermontCulture_Entry {
                id
                slug
                title
                geolocalisation {
                  lat
                  lng
                }
                clermontType {
                  ... on clermontType_Category {
                    id
                    slug
                    color
                    title
                    image {
                      url
                      id
                    }
                  }
                }
              }
            }
          }
        `,
        variables: { categories }
      })
      .then(res => {
        const result = res.data.entries

        resolve(result)
        storage.setItem( `fetchCultures_${JSON.stringify(args)}`, result)
      })
      .catch(err => {
        console.error('Error catching global params ', err)
      })
    })
    const cache = storage.getItem( `fetchCultures_${JSON.stringify(args)}`)

    return {
      request,
      cache
    }
  }

  imgSize ({id, width, height}) {
    const args = arguments

    const request = new Promise((resolve, reject) => {
      let query = {}

      if (width && height) {
        query = {
          query: gql`
            query fetchImg ($id: [QueryArgument], $width: Int, $height: Int) {
              asset(id: $id) {
                ... on default_Asset {
                  url(width: $width, immediately: true, height: $height)
                }
              }
            }
          `,
          variables: { id, width, height }
        }
      }
      else if (width && !height) {
        query = {
          query: gql`
            query fetchImg ($id: [QueryArgument], $width: Int) {
              asset(id: $id) {
                ... on default_Asset {
                  url(width: $width, immediately: true)
                }
              }
            }
          `,
          variables: { id, width }
        }
      }
      else if (!width && height) {
        query = {
          query: gql`
            query fetchImg ($id: [QueryArgument], $height: Int) {
              asset(id: $id) {
                ... on default_Asset {
                  url(height: $height, immediately: true)
                }
              }
            }
          `,
          variables: { id, height }
        }
      }
      else {
        query = {
          query: gql`
            query fetchImg ($id: [QueryArgument])  {
              asset(id: $id) {
                ... on default_Asset {
                  url
                }
              }
            }
          `,
          variables: { id }
        }
      }

      graphqlClient.query(query)
        .then(res => {
          resolve(res.data.asset.url)

          const result = res.data.asset.url

          resolve(result)
          storage.setItem( `fetchImg_${JSON.stringify(args)}`, result)
        })
        .catch(err => {
          console.error('Error catching global params ', err)
        })
    })

    const cache = storage.getItem(`fetchImg_${JSON.stringify(args)}`)

    return {
      request,
      cache
    }
  }
}

export const api = new APICraft()